import React, { Component } from "react";
import App from "../../App";
import { Button } from "react-bootstrap";
import Pagination from "react-js-pagination";
import { withRouter } from "react-router-dom";
import "../../assets/scss/order-list.scss";
import { ToastsContainer, ToastsStore } from "react-toasts";
import DateRangePicker from "react-bootstrap-daterangepicker";
import { getPaginatedList, getList } from "../../services/baseServices";
import { getFormattedDate } from "../../helper/utils";
import Loader from 'react-loader';

import ExportCSVAsync from "../common/ExportCSVAsync";
import moment from "moment";

const headers = [
    {label: "Transaction Id.", key: "id"},
    {label: "Chalan No", key: "chalan_no"},
    {label: "Transaction Date", key: "created_at"},
    {label: "Supplier", key: "supplier_name"},
    {label: "From Bank", key: "debit_bank_name"},
    {label: "To Bank", key: "credit_bank_name"},
    {label: "Amount", key: "amount"},
];

var startDate = moment().subtract(29, 'days');
var today = moment();

const loadData = (item) => {
    return {
        id: item.id,
        chalan_no: item.chalan_no,
        supplier_name: item.supplier_name,
        amount: item.amount,
        created_at: getFormattedDate(item.created_at, "LT Do MMMM YYYY"),
        debit_bank_name: item.debit_bank_name,
        credit_bank_name: item.credit_bank_name
    };
};

class List extends Component {
    constructor() {
        super();
        this.state = {
            collections: [],
            isLoading: true,
            activePage: 1,
            per_page: 15,
            page: 1,
            temp_params: {start_date_time: startDate.format("YYYY-MM-DD"), end_date_time: today.format("YYYY-MM-DD")},
            query_params: {start_date_time: startDate.format("YYYY-MM-DD"), end_date_time: today.format("YYYY-MM-DD")},
            isExporting: false,
            start_date_time: startDate,
            end_date_time: today,
            suppliers: []
        };
    }

    getQueryParams = () => {
        let params = Object.assign(this.state.query_params, {per_page: this.state.per_page, page: this.state.page});
        return params;
    }

    getPaginatedCashCollection = (params) => {
        this.setState({...this.state, isLoading: true});
        getPaginatedList("bank_transactions/get_supplier_payment", params)
            .then(res => {
                this.setState({
                    collections: res.data,
                    isLoading: false,
                    per_page: res.headers['x-per-page'],
                    total_data: res.headers['x-total'],
                }, () => {
                });
            })
            .catch(errMsg => {
                this.setState({...this.state, isLoading: false});
                console.log('Error Message: ', errMsg)
            })
    }

    componentDidMount() {
        this.getPaginatedCashCollection(this.getQueryParams());
        getList("suppliers")
          .then((res) => {
            this.setState({ suppliers: res });
          })
          .catch((errMsg) => {});
    }

    handleOnSearch = (e) => {
        e.preventDefault();
        const tempParam = this.state.temp_params;
        console.log(tempParam)
        this.setState({...this.state, page: 1, query_params: tempParam}, () => {
            this.getPaginatedCashCollection(this.state.temp_params);
        });
    }

    handleOnFieldChange = (e) => {
        const queryData = {...this.state.temp_params};
        queryData[e.target.name] = e.target.value;
        this.setState({temp_params: queryData}, () => {
        });
    }

    handlePageChange = (pageNumber) => {
        this.setState({page: pageNumber, activePage: pageNumber}, () => {
            this.getPaginatedCashCollection(this.getQueryParams());
        });
    }

    handleOnApply = (e, picker) => {
        this.setState({
            start_date_time: getFormattedDate(picker.startDate, ''),
            end_date_time: getFormattedDate(picker.endDate, '')
        })
        this.setState({
            temp_params: {
                ...this.state.temp_params,
                start_date_time: getFormattedDate(picker.startDate, "YYYY-MM-DD"),
                end_date_time: getFormattedDate(picker.endDate, "YYYY-MM-DD")
            }
        })
    }

    render() {
        return (
            <App layout="">
                <div className="main-content">
                    <div className="page-header">
                        <h2 className="page-title">Supplier Payment List</h2>
                        <div className="ml-auto d-flex">
                            <ExportCSVAsync
                                fileName={
                                    "Supplier-Payments-" + getFormattedDate(new Date(), "DD-MM-YYYY") + ".csv"
                                }
                                Url="bank_transactions/export_supplier_payment"
                                headers={headers}
                                params={this.state.query_params}
                                loadData={loadData}
                                title="Supplier Payment List"
                            />
                        </div>
                    </div>
                    <form className="form-inline mb-3">
                        <div className="form-group mr-3">
                            <label htmlFor="status" className="sr-only">
                                Date Range
                            </label>
                            <DateRangePicker
                                initialSettings={{
                                    startDate: this.state.start_date_time,
                                    endDate: this.state.end_date_time,
                                    maxSpan: {"months": 3},
                                    showDropdowns: true,
                                    locale: {format: "DD/MM/YYYY"},
                                    autoApply: true,
                                }}
                                onApply={(e, picker) => this.handleOnApply(e, picker)}
                            >

                                <input type="text"
                                       value={this.state.start_date_time && this.state.end_date_time ? `${getFormattedDate(this.state.start_date_time, "DD/MM/YYYY")} - ${getFormattedDate(this.state.end_date_time, "DD/MM/YYYY")}` : ''}
                                       style={{textAlign: 'left', minWidth: '150px'}}
                                       placeholder={"Select date range"}
                                       className="form-control form-control-sm"/>
                            </DateRangePicker>
                        </div>
                        <div className="form-group mr-3">
                            <label htmlFor="supplier_id" className="sr-only">
                                Supplier
                            </label>
                            <select
                                id="supplier_id"
                                name="supplier_id"
                                value={this.state.temp_params.supplier_id}
                                className="form-control form-control-sm"
                                onChange={(e) => {
                                    this.handleOnFieldChange(e);
                                }}
                            >
                            <option value="">--Select Supplier--</option>
                            {this.state.suppliers?.length > 0
                                ? this.state.suppliers.map((item, i) => {
                                    return (
                                    <option key={i} value={item.id}>
                                        {item.supplier_name}
                                    </option>
                                    );
                                })
                                : ""}
                            </select>
                        </div>
                        <Button
                            size="sm"
                            type={`submit`}
                            onClick={this.handleOnSearch}
                            variant="primary"
                        >
                            Filter
                        </Button>
                    </form>
                    <Loader loaded={!this.state.isLoading}>
                        <div className="card-block">
                            <div className="block-body">
                                <table className="order-table table table-striped">
                                    <thead>
                                    <tr>
                                        <th>Transaction Id</th>
                                        <th>Chalan No</th>
                                        <th>Transaction Date</th>
                                        <th>Supplier</th>
                                        <th>From Bank </th>
                                        <th>To Bank </th>
                                        <th>Amount</th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    {this.state.collections?.length > 0 ? (
                                        this.state.collections.map((c, index) => {
                                            return (
                                                <tr key={index}>
                                                    <td>
                                                        <div className="order-item">
                                                            {c.id}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {c.chalan_no}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {getFormattedDate(c.created_at, "DD-MM-YYYY")}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {c.supplier_name}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {c.debit_bank_name}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {c.credit_bank_name}
                                                        </div>
                                                    </td>
                                                    <td>
                                                        <div className="order-item">
                                                            {c.amount}
                                                        </div>
                                                    </td>
                                                </tr>
                                            );
                                        })
                                    ) : (
                                        <tr>
                                            <td colSpan={9} className="text-center">
                                                {" "}
                                                <h5>No Order Found</h5>
                                            </td>
                                        </tr>
                                    )}
                                    </tbody>
                                </table>
                            </div>
                            <div className="mt-3">
                                <Pagination
                                    itemClass="page-item"
                                    linkClass="page-link"
                                    activePage={this.state.activePage}
                                    itemsCountPerPage={this.state.per_page}
                                    totalItemsCount={this.state.total_data}
                                    pageRangeDisplayed={10}
                                    onChange={this.handlePageChange.bind(this)}
                                />
                            </div>
                        </div>

                    </Loader>
                </div>
                <ToastsContainer store={ToastsStore}/>
            </App>
        );
    }
}

export default withRouter(List);
